import type { DeskApp } from '@/types/desk';
import { AppStatus, AppType } from '@/types/desk';
import axios from '@/utils/axios';
import { arrayEach } from '@isyscore/utils/array';
import { Module } from 'vuex';
import { RootState } from './../index';

interface DesktopPicture {
    id: string;
    configType: string;
    pictureUrl: string;
    used: 1 | 0;
}

interface DesktopPictureConfig {
    logo: DesktopPicture[];
    background: DesktopPicture[];
}

export interface DeskState {
    // 允许的应用列表
    allowedApps: DeskApp[];

    // 当前背景图片
    background: string;

    // 品牌 logo
    brandLogo: string;

    // 品牌名称
    brandName: string;

    // 品牌描述
    powerby: string;
}
export const deskModule: Module<DeskState, RootState> = {
    namespaced: true,

    state: {
        allowedApps: [],
        background: '',
        brandLogo: '',
        brandName: '',
        powerby: ''
    },

    mutations: {
        setBrandLogo(state, url: string) {
            state.brandLogo = url;
        },

        setBackgroundImage(state, image: string) {
            state.background = image;
        }
    },

    actions: {
        async getAllowedApps({ state }) {
            try {
                // @todo 可以精确更新，而不是全量替换
                const allowedApps = await axios.get<DeskApp[]>('/api/ops/config/user/desktop/getMenuList');

                state.allowedApps = allowedApps.filter(
                    ({ status, type }) => status === AppStatus.STARTED && type !== AppType.HIDDEN_APP
                );
            } catch (err) {
                state.allowedApps = [];
            }
        },

        async getBrandConfig({ state }) {
            try {
                const data = await axios.request<DesktopPictureConfig>({
                    url: '/api/ops/config/picture/desktop'
                });
                state.brandLogo = data.logo?.[0]?.pictureUrl;
                arrayEach(data.background, (item) => {
                    if (item.used === 1) {
                        state.background = item.pictureUrl;
                        return false;
                    }
                });
                state.background = state.background || data.background[0].pictureUrl;
            } catch (err) {
                // ignore
            }

            try {
                const params = { appName: 'isc-sys-config-service' };
                const data = await axios.get<{
                    logo: string;
                    enterprise: string;
                    powerby: string;
                }>('/api/ops/config/common/page/configGet', { params });
                state.brandLogo = state.brandLogo || data.logo;
                state.brandName = data.enterprise;
                state.powerby = data.powerby || 'POWERED BY ISYSCORE';
            } catch (err) {
                // ignore
            }
        }
    }
};
